export default __webpack_public_path__ + "static/media/sera.49da91eb.png";